import { Box, useStyleConfig } from '@chakra-ui/react';
import { SUP_SUB_STYLES } from '@time-line/components/constants';
import type { ReactNode } from 'react';

interface ContainerProps {
  children: ReactNode;
}

export function AboutPageMissionContainer({ children }: ContainerProps) {
  const textStyles = useStyleConfig('Text', { size: 'large-serif' });

  return (
    <Box
      textAlign="center"
      sx={{
        '> p.chakra-text': {
          ...textStyles,
          '&:not(:last-of-type)': {
            pb: 'sm',
          },
        },
        ...SUP_SUB_STYLES,
      }}
    >
      {children}
    </Box>
  );
}

export function LongevityDayContainer({ children }: ContainerProps) {
  const bodyStyles = useStyleConfig('Text', { size: 'body2' });

  return (
    <Box
      gridColumn="span 12"
      sx={{
        '> p.chakra-text, span.chakra-text': {
          ...bodyStyles,
          fontVariantNumeric: 'tabular-nums',
        },
        '> p.chakra-text + p.chakra-text': {
          mt: '2xs',
        },
        '> p a span': {
          whiteSpace: 'pre-wrap',
        },
        'a:not(.chakra-link)': { textDecoration: 'underline' },
      }}
    >
      {children}
    </Box>
  );
}

export function SectionHeaderContainer({ children }: ContainerProps) {
  const bodyStyles = useStyleConfig('Text', { size: 'body2' });

  return (
    <Box
      sx={{
        '> .chakra-text': {
          ...bodyStyles,
        },
      }}
    >
      {children}
    </Box>
  );
}
